import { styled } from "styled-components";

import { redundantCssFromKebab } from "../../styles/redundant-css";

export type LinkBlockProps = {
    lighten?: boolean;
    lift?: boolean;
};

export const LinkBlock = styled.div<LinkBlockProps>`
    ${redundantCssFromKebab("opacity", "1")}
    ${redundantCssFromKebab("transform", "translate3d(0, 0, 0)")}
    ${redundantCssFromKebab("transition", "250ms ease-out")}

    > a {
        ${redundantCssFromKebab("display", "block")}
        ${redundantCssFromKebab("text-decoration", "none")}
    }

    &:hover,
    &:focus:focus-visible {
        ${redundantCssFromKebab(
            "opacity",
            `${({ lighten }) => (lighten ? 0.8 : 1)}`
        )}
        transform: ${({ lift }) =>
            lift ? "translate3d(0, -4px, 0)" : "translate3d(0, 0, 0)"};
    }
`;
